import React from 'react';
import { Label } from './Label';

const baseInput =
  'w-full px-3 py-2.5 text-base rounded-lg border transition-all duration-200 box-border ' +
  'bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 ' +
  'border-gray-300 dark:border-gray-600 ' +
  'focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-brand-500 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export function inputClassName(hasError = false, className = '') {
  const errorClasses = hasError
    ? 'border-red-400 dark:border-red-500 focus:ring-red-400 focus:border-red-500'
    : '';
  return `${baseInput} ${errorClasses} ${className}`.trim();
}

export function FieldError({ error }) {
  if (!error) return null;
  return <p className="mt-1.5 text-sm text-red-600 dark:text-red-400">{error}</p>;
}

export function FieldHint({ hint }) {
  if (!hint) return null;
  return <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">{hint}</p>;
}

/**
 * Centralised text input. Use `label` / `error` / `hint` to avoid
 * copy-pasting label+input+error markup in every modal.
 */
export function Input({
  id,
  label,
  error,
  hint,
  required = false,
  className = '',
  ...props
}) {
  return (
    <div className="w-full">
      {label && (
        <Label htmlFor={id} required={required}>
          {label}
        </Label>
      )}
      <input id={id} required={required} className={inputClassName(!!error, className)} {...props} />
      <FieldError error={error} />
      <FieldHint hint={hint} />
    </div>
  );
}

export default Input;
